export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20dark%20composition%20with%20soft%20warm%20amber%20and%20deep%20burgundy%20gradients%2C%20flowing%20organic%20shapes%20reminiscent%20of%20flower%20petals%20in%20motion%2C%20rich%20textured%20background%20with%20subtle%20light%20streaks%2C%20cinematic%20atmosphere%2C%20mysterious%20and%20refined%20aesthetic%2C%20dark%20background%20with%20warm%20golden%20accents%20like%20scattered%20pollen%20particles%2C%20no%20text%2C%20no%20people%2C%20abstract%20art%20style&width=1600&height=900&seq=hero-tanhua-main&orientation=landscape"
          alt="探花系列主视觉"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-block px-3 py-1 mb-4 text-xs font-medium tracking-wider uppercase text-primary-300 border border-primary-400/30 rounded-full bg-primary-500/10 backdrop-blur-sm">
              官方认证 · 安全访问
            </p>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
              探花系列 · 精品资源导航
            </h1>

            <p className="text-base md:text-lg text-white/70 font-medium tracking-wide mb-6">
              探花最新地址发布页，一站式资源入口
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl lg:max-w-none mb-8">
              探花系列致力于打造安全稳定的探花官网入口与探花最新地址发布平台，实时更新探花新地址，防止用户走失。
              本站聚合探花在线免费资源与探花精选合集，覆盖精品探花内容导航，提供便捷可靠的探花入口访问体验。
              当前已收录海量优质资源，每日持续更新，确保每一位访客都能安全快速地找到优质内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">3000+</p>
                <p className="text-xs text-white/50 mt-1">精选资源</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</p>
                <p className="text-xs text-white/50 mt-1">内容保障</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">多重防护</p>
                <p className="text-xs text-white/50 mt-1">安全访问</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line text-base"></i>
                探索精选
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-white/30 hover:border-white/60 text-white font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer bg-white/5 hover:bg-white/10"
              >
                <i className="ri-arrow-right-line text-base"></i>
                查看最新
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20floral%20composition%20with%20warm%20golden%20amber%20tones%20and%20deep%20crimson%20accents%2C%20soft%20flowing%20silk%20fabric%20textures%20intertwined%20with%20organic%20petal%20shapes%2C%20rich%20dark%20background%20with%20dramatic%20lighting%2C%20luxurious%20and%20refined%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20artistic%20photography%20style%20with%20soft%20bokeh%20effects%2C%20no%20text%2C%20no%20people&width=960&height=720&seq=hero-tanhua-visual&orientation=landscape"
                alt="探花系列精品内容视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}